import { createContext } from 'react';

import { MaintenanceWindow } from '@totem/components/maintenanceWindowsV2/types';

interface Context {
  loading: boolean;
  // 404: not in the user's organization or outside their data access.
  notFound: boolean;
  data: MaintenanceWindow;
  now: number;
  sending: boolean;
  // Ticket number by ticket id for the window's linked tickets (missing until loaded or if not readable).
  ticketNumbers: Record<string, string>;
  onAction: (action: string) => void;
}

export default createContext<Context>({
  loading: false,
  notFound: false,
  data: null,
  now: Date.now(),
  sending: false,
  ticketNumbers: {},
  onAction: () => {},
});
